import { type Component, type InjectionKey } from 'vue';

export type BreadcrumbItemProps = { href: string };

export const registerBreadcrumbItemKey = Symbol('registerBreadcrumbItem') as InjectionKey<
  (props: BreadcrumbItemProps, item: Component) => () => void
>;
